import Model, { attr, belongsTo } from '@ember-data/model';
import type InvoiceModel from './invoice.ts';
import type EmployeeModel from './employee.ts';
import { Type } from '@warp-drive/core-types/symbols';

export default class InvoiceLineItemModel extends Model {
  @attr declare amount: number;
  @attr declare description: string;
  @attr declare lineItemType: string;

  /*************************
   **  Relationships      **
   *************************/

  @belongsTo('invoice', { async: false, inverse: null })
  declare invoice: InvoiceModel;
  @belongsTo('employee', { async: false, inverse: null })
  declare employee: EmployeeModel;

  [Type] = 'invoice-line-item' as const;
}
